// extracted by mini-css-extract-plugin
export default {"container":"Offers_container__Cnj8c","load-button":"Offers_load-button__4SfIb"};